export const OPTION_LABEL_ACCESSORS = ['ans_opt', 'option_value'];
